module.exports = __webpack_public_path__ + "img/五灵脂.6d9afdc1.jpg";